import React, { memo } from "react";
import InvalidPage from "../common-components/InvalidPage";

const Unauthorized = () => {
  return (
    <InvalidPage
      image={"/assets/images/unauthorized.svg"}
      title={`Oops! There seems to be an issue accessing this page`}
      subtitle="Please verify your credentials or access token"
    />
  );
};

export default memo(Unauthorized);
